import React, { useEffect, useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';

export default function ProjectsFab() {
  const [visible, setVisible] = useState(false);
  const [nearProjects, setNearProjects] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || 0;
      setVisible(y > 280);

      const section = document.getElementById('project');
      if (!section) {
        setNearProjects(false);
        return;
      }
      const rect = section.getBoundingClientRect();
      const inView = rect.top < window.innerHeight * 0.55 && rect.bottom > 120;
      setNearProjects(inView);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  if (!visible || nearProjects) return null;

  return (
    <ScrollLink
      to="project"
      spy={true}
      smooth={true}
      offset={-80}
      duration={600}
      className="projects-fab"
      aria-label="View projects"
    >
      <span className="projects-fab__icon" aria-hidden="true">
        ❐
      </span>
      <span className="projects-fab__text">View projects</span>
    </ScrollLink>
  );
}
